// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onboarding-container[data-v-6064b0cc]{min-height:186px}.stepper-background[data-v-6064b0cc]{background-color:#f4f8fa;border-radius:6px;box-shadow:0 2px 5px rgba(0,0,0,.2);max-width:1137px!important}@media only screen and (max-width:959px){.onboarding-container[data-v-6064b0cc]{max-width:none!important;padding:0;padding-top:6px!important}}@media only screen and (max-width:1263px){.container[data-v-6064b0cc]{max-width:none!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
